import * as types from '../mutation-types';
import {unionState, toDateTimeString} from '../helpers';

const state = () => ({
	companyValues: [],
});

const actions = {
	fetchAll({commit}) {
		return axios.get('/api/company-values').then(response => {
			commit(types.STORE_COMPANY_VALUES, response.data);
		});
	},

	create({commit}, {content, image}) {
		const formData = new FormData();
		formData.append('title', content);
		formData.append('image', image);

		return axios.post('/api/company-values', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_COMPANY_VALUE, response.data);

			return response.data;
		});
	},

	fetch({commit}, {id}) {
		return axios.get(`/api/company-values/${id}`).then(response => {
			commit(types.STORE_ONE_COMPANY_VALUE, response.data);

			return response.data;
		});
	},

	delete({commit}, {id}) {
		return axios.delete(`/api/company-values/${id}`).then(() => {
			commit(types.DELETE_COMPANY_VALUE, id);
		});
	},
	
	update({commit}, {id, content, image}) {
		const formData = new FormData();
		formData.append('title', content);

		if (image)
			formData.append('image', image);

		formData.append('_method', 'PUT');

		return axios.post(`/api/company-values/${id}`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_COMPANY_VALUE, response.data);

			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_COMPANY_VALUES](state, values) {
		state.companyValues = unionState(state.companyValues, values);
	},

	[types.STORE_ONE_COMPANY_VALUE](state, value) {
		state.companyValues = unionState(state.companyValues, [value]);
	},

	[types.DELETE_COMPANY_VALUE](state, id) {
		const value = state.companyValues.find(p => p.id === id);
		value.deleted_at = toDateTimeString(new Date());
	},
};

const getters = {
	getById: state => id => state.companyValues.find(c => c.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};